import { openDB } from "idb";

const DB_NAME = "BabakDB";
const DB_VERSION = 4;
const STORE_NAME = "ColumnsDG"; 
// const STORE_NAME = "settings";// مثال: فرض می‌کنیم نام فروشگاه این است

export async function initDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        // اگر کلیدها را دستی می‌دهید، این خط کافیست.
        // اگر آبجکت‌هایتان فیلد 'id' دارند و می‌خواهید اتوماتیک باشد:
        // db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
        db.createObjectStore(STORE_NAME);
      }
    },
  });
}

// تابع برای خواندن مقدار - بهتر است خطاها را هم مدیریت کند
export async function getSetting(key) {
  try {
    const db = await initDB();
    return await db.get(STORE_NAME, key);
  } catch (error) {
    console.error(`Error getting setting for key "${key}":`, error);
    return undefined; // یا مقدار پیش‌فرض مناسب دیگر
  }
}

// تابع اصلی برای ذخیره کردن (با قابلیت Merge)
export async function setSetting(key, valueToMerge) {
  try {
    const db = await initDB();
    const existingValue = await getSetting(key);

    let finalValue;
    if (existingValue === undefined) {
      // اگر کلید وجود ندارد، همان مقدار جدید را ذخیره کن
      finalValue = valueToMerge;
    } else {
      // اگر کلید وجود دارد، مقادیر را Merge کن
      // فرض بر این است که هم existingValue و هم valueToMerge آبجکت هستند
      // اگر valueToMerge یک آبجکت نیست، این منطق باید تغییر کند
      if (typeof valueToMerge === 'object' && valueToMerge !== null && typeof existingValue === 'object' && existingValue !== null) {
        finalValue = { ...existingValue, ...valueToMerge };
      } else {
        // اگر یکی از مقادیر آبجکت نیست، مقدار جدید را جایگزین کن (مانند رفتار اولیه put)
        finalValue = valueToMerge;
      }
    }
    return await db.put(STORE_NAME, finalValue, key);
  } catch (error) {
    console.error(`Error setting setting for key "${key}":`, error);
    throw error; // خطا را دوباره پرتاب کن تا در جای دیگری مدیریت شود
  }
}

// تابع حذف - بهتر است خطاها را هم مدیریت کند
export async function deleteSetting(key) {
  try {
    const db = await initDB();
    return await db.delete(STORE_NAME, key);
  } catch (error) {
    console.error(`Error deleting setting for key "${key}":`, error);
    throw error;
  }
}

